import { motion } from "framer-motion";

const frames = [
  {
    src: "https://images.pexels.com/photos/23995753/pexels-photo-23995753.jpeg",
    alt: "Kilkenny Castle, Ireland",
    caption: "Kilkenny Castle — our neighbour, our heritage",
    testid: "gallery-image-castle",
    span: "lg:col-span-7",
    aspect: "aspect-[16/10]",
  },
  {
    src: "https://images.pexels.com/photos/4476378/pexels-photo-4476378.jpeg",
    alt: "Bookkeeper writing figures while using a calculator",
    caption: "The daily craft of the ledger",
    testid: "gallery-image-ledger",
    span: "lg:col-span-5",
    aspect: "aspect-[4/3]",
  },
  {
    src: "https://images.pexels.com/photos/6863203/pexels-photo-6863203.jpeg",
    alt: "Tax documents and calculator on a desk",
    caption: "Revenue-ready, every deadline",
    testid: "gallery-image-tax",
    span: "lg:col-span-5",
    aspect: "aspect-[4/3]",
  },
  {
    src: "https://images.pexels.com/photos/36704548/pexels-photo-36704548.jpeg",
    alt: "Castle grounds in Kilkenny with a walker",
    caption: "Rooted in the marble city",
    testid: "gallery-image-grounds",
    span: "lg:col-span-7",
    aspect: "aspect-[16/10]",
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

export default function Gallery() {
  return (
    <section data-testid="gallery-section" className="border-t hairline-gold py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div {...fadeUp}>
          <p className="overline-label mb-6 flex items-center gap-4" data-testid="gallery-overline">
            <span className="inline-block h-px w-10 bg-gold" />
            The City &amp; The Craft
          </p>
          <h2 className="max-w-xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-navy sm:text-5xl" data-testid="gallery-heading">
            Kilkenny, in <em className="italic text-gold">frame.</em>
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          {frames.map((f, i) => (
            <motion.figure
              key={f.testid}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: i * 0.12 }}
              className={f.span}
              data-testid={f.testid}
            >
              <div className="group relative">
                <div className="absolute -left-3 -top-3 h-full w-full border hairline-gold transition-transform duration-500 group-hover:-translate-x-1 group-hover:-translate-y-1" aria-hidden="true" />
                <div className={`relative ${f.aspect} overflow-hidden`}>
                  <img
                    src={f.src}
                    alt={f.alt}
                    loading="lazy"
                    className="h-full w-full object-cover grayscale-[45%] transition-all duration-700 group-hover:scale-[1.03] group-hover:grayscale-0"
                  />
                  <div className="absolute inset-0 bg-navy/10 transition-opacity duration-700 group-hover:opacity-0" />
                </div>
              </div>
              <figcaption className="mt-4 font-serif text-base italic text-navy/60">
                {f.caption}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
